// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"_3_vYm4","legalLinks":"_396wju"};